var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a4c2d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40 28.8-.4.5-.6-.2s-.3.5-.5.5h-.6l-.5-.1v-.2l-.7.5c-.2 0-.6-.7-.6-.7l-.1.4h-.9l-.8-.6-.4.7-.8.2v-.1l-.5-.3.4-.6h-.2l-.3.2-.6.3-.5-.2.2-.5v-.3l.5-.7 5.5-5.4 2.7 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.8 29h1.5l-.6-.3 5.4-.2-.7-.3-.7-1-2.9-.1-.5-.1q-.1-.4-.3-.5l-1.7-.1-1.1.7.7 1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.2 13 .2-.5.2-.6.2-.4s.6-.2.7.2c.7-1 1.4 0 1.4 0l.2-.3.4-.5.6.6h.7l.3.7c.2.1.4.9.4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656263",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.8 18.8q.4 0 .5-.6-.2-.7-.8-.6l-.4.2-.9-.5s.5-2.5.9-2.7l.5-.5-.2-.2-2.6-.3-2.5.3-.2.4.5.6c.5.3.8 2.5.8 2.5l-.7.3h-.4s-.4.2-.4.7q.1.6.3.7s2.4-.3 2.8.4c.3-.8 2.6-.5 2.8-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m46.4 16.2.2-.4c.2-.2 1.5-.2 1.9 0s.4 1.1.4 1.1l.2.7v.4s1.1 1.3 1.1 2.6c.1.8.1 3-.2 4q0 1-.5 1.7l.1.4-.1.4 1.5.7-.5-.2.5.5-.6-.3.4.4-1-.4.5.4-.7-.4.4.5-.6-.3v.2s-.5 0-.5-.4l-.4-.3-1-.2-1.3-3.7.3-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.6 36.2s-.7-1.3-1-1.3c-.3-.6 1-5 3.5-5.3 1.4.1.1 1.6-.8 1.1q.2.6.6 1s-1.8.8-2.3 4.5Zm-8.5.2s.5-1.5.8-1.5-.8-5-3.4-5.1c-1.4 0 0 1.6.8 1.1q-.1.5-.6 1s1.8.7 2.4 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00713d",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.4 27c0-.1-.6.1-.2.8q.1-.4.3-.4s-.5.5 0 .9q.1-.5.3-.5s-.3 1 0 1.1q.1-.6.3-.5s-.3.8 0 1l.2-.5s-.1.9.2 1q.1-.5.3-.6s-.1.7.4.7v-.6s.3.8.7.7v-.7s.2.7.6.6v-.4s.2.4.6.3v-.4s.6.6.8.2-.5-.5-.5-.5h.5q0-.2-.8-.4h.4s0-.5-.7-.6h.5q.2-.1-.7-.6h.4s-.3-.4-.6-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3ec26d",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m42 29.1.3.2m-.1-.4.3.4m0-.5.2.4m.2-.3v.3m.2-.1v.2m-3-1.6.3.5M40 28v.2m.3-.4.2.4m.2-.3v.3m.1-.2v.2m-.1.4.3.2m-.1-.4.3.3m0-.4.2.4m.2-.4v.4m.2-.3v.4m-.3-.9.1.3m0-.4q.2 0 .2.3m.1-.4.1.4m.2-.4v.4m.3-.2-.1.2m-1 1v.2m-.3-.4v.4m-.3-.4.1.3m-.4-.3.1.3m-.2 0 .1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.4 19.1h2s1.4 0 1.5.4c.3-.6 1.5-.5 1.5-.5l2-.1v5a5 5 0 0 1-3.3 4 5 5 0 0 1-3.4-4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006b00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.2 19 3 8 2.6-8c-.9 0-2.6-.2-2.9.5-.3-.6-2.2-.4-2.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M40.2 23.3s0-2 .2-2.2l.1-.4c0-.2-.7-.2-.9 0l.2.4c.3.4.2 2.3.4 2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdad56",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m39.4 6.4.2-.3s1 0 1.5-1.1c.3-.6 0-.2 0-.2v-.3s.4-.4.2-.6c-.1-.2 0 .3-.3.3s-.1-.5-.1-.5v-.1l-.2.2-.2-.4s-.1-.2-.3.4c.1.6.5.5.5 1q-.2.7-.5.7V5H40q.1.1.2-.5c-.1-.6-.2 0-.3 0-.2 0 0-.5 0-.5s0-.3-.4.3c0 .3 0 0-.2 0l.1.6q.4.3.4.5t-.3.4q-.2-.1 0-.4l-.3-.5-.2-.4-.1.3c0 .4-.2-.2-.2-.2q-.1.1.1.7h-.2l.3.4q-.1.3-.3.3s.2.2.6-.2l-.2.4q.3 0 .3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cdad56",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m38 6.4-.1-.3s-.9 0-1.3-1c-.2-.5 0-.2 0-.2v-.2l-.1-.6c0-.1 0 .3.2.3s0-.5 0-.5h.2l.1.2.3-.3s0-.3.2.2c0 .6-.5.5-.5.9q.1.7.3.7l.1-.4v-.1l-.2-.4c.1-.4.3 0 .4 0v-.5s.2-.3.3.3c0 .3.1-.2.2-.2q.1.3-.2.7t-.2.5l.1.2.1-.2.3-.4v-.3l.2.2c0 .3.2-.2.2-.2l-.1.6h.1V6q.1.2-.4-.1l.1.3q-.2 0-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    d: "m43.3 20.3-.3-.1h-.1l-.1-.2v.4l-.2.2V20h-.2l-.1.1h-.4l.2-.1.1-.2h.2l-.1-.2H42l-.1-.3.1.1h.3l.1.1v-.3l.2-.3v.3l.1.1v.2h.1l.2-.1h.2l-.1.1-.1.2h-.2v.1l.3.1zm-4.5 0h.2l.1-.1h.2v.3l.2.2-.1-.2.1-.1V20h.2v.2h.4l-.2-.1V20h-.2v-.2h.2l.2-.3-.2.1h-.2l-.2.1v-.3l-.1-.3v.3h-.2v.3h-.1l-.1-.2h-.3l.2.2v.2h.2v.1h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M43.1 20.8c-.1 0-1.2.3-1.2 1.2 0 1 .2 1.1 0 1.2-.4 0-.4-1-.4-1.5v-.3q.2 0 .2.2c0 .3.3-.5.2-.7q.3.2.4 0l-.2-.2.2.1-.2-.2c-.3 0 0 0 0 0h.3l-.3-.3-.3-.3h-.5v.6h.3q0 .4-.3.1H41l.2.3-.4.1h.3l-.4.3v-.1l-.4-.1v.5l.3.1q.1-.2.4-.2l-1 .8-.2-.2v.2c.1 0-.3 0-.2.3q.1.2.2 0h.2l.3-.2-.3.1-.2.1.1.2q.1-.1.4 0 .4-.1.2-.5l.1.4s.5-.3.2-.5l.1.3h.2q0 0 0 0l.1.4-.1-.1-.5.2c-.2 0 .2.6.2.6h-.3l-.2-.1q0 0 0 0l-.2.1v.2h.2-.2v.3h.2q0 0 0 0l.3-.2v.2l.3-.2v.1h.2l-.1.7q-.4-.2-.4 0v.5l.2-.1.2-.1v-.2.2q-.2 0-.2.2l.2.1.2-.3h.2q-.2-.3 0-.4.2 0 0 .1l.1.3s.2-.5 0-.6l.2.2s.2-.5 0-.5l-.2-.1V24l.3.2-.2-.4c-.3-.1 0-.4 0-.4q0 .2.3 0 0 0 0 0l.4-.4h-.2l.2-.4-.2.1.1-.4q0 .2-.2.2s-.2-.8.1-.8q.3.1.2.3s.4-.1 0-.4l.3.1s0-.5-.6-.2l.3-.1q.3 0 .5-.2h-.4s.7 0 .6-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M39.7 21q.2-.2.7.1m.2.5-.2.1m.4.3.7-.3m-.2.3v.1h-.1v.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    d: "m41 24.8-.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m41 24.8-.2.1m.4-.9v-.5q0-.2.3-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006b00",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M41.2 23.7q0 .2-.6.2m.7-.9s0 .4-.4.3m-.1-1.9-.1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006b00",
    d: "m41.4 21 .3-.1.1-.2v-.3q0-.2.2 0 .1-.2-.2-.3h-.3v.3l.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    stroke: "#ffc900",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41.6 20.3q0 0 0 0t0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    stroke: "#006b00",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M41 25.3v.3-.2Zm-.3-.3-.2.2h.2zm0-.1h-.1zm-.5-1.4v.1q.2-.1 0 0Zm-.2.2h.2zm0 .3h.1zm-.2-1.8h-.1l.1.1Zm-.2.7v-.2h.1zm.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    stroke: "#006b00",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m39.7 21.3.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e80000",
    stroke: "#006b00",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.9 21.2v.1zm0 .3h.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc900",
    stroke: "#006b00",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M39.7 21q0 .2.2.2 0-.2-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M39.8 20.5h.7q.3.3.2.1l.5.1c.2-.1-.2 0-.3-.2l-.1-.2v-.4q-.2 0-.2.2c-.2 0 0-.3-.3-.4l-.1.4c-.1 0-.6.3-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c01500",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M34.5 35.4c.3 0 2 .4 2.5 1l-.4-2s-1-.3-1.1-.2zM34 30l-.3.3c-.2.3-.2 1.2-.4 1.3q-.4.2-.4.4-.1.4.5.7c.5 0 1.3-.8 1.3-.8s.5-.4.6-1c-1 .4-1.6-.5-1.3-.9Zm14.1 5.3q-1.4 0-2.5 1 .3-1.8.5-2l1-.2zm.5-5.4.3.3q0 .6.4 1l.4.6q.1.3-.6.6c-.5 0-1.2-.6-1.2-.6l-.6-1c1 .4 1.6-.5 1.3-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fb0",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M33.5 34.4s1 .7 1 1c2.7-4 9.7-5.3 13.6-.3l1-1a9.8 9.8 0 0 0-15.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e5aa6",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.8 19h.4l-.7.8.8 1-1.7 2.1 1.6 2q-.1.5-.6 1l-1-1 1.7-2-1.3-1.5zM38 19h-.4l.8.9-.9 1 1.8 2-1.5 1.9.7 1.2.9-1-1.8-2 1.3-1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e5aa6",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40 24.2-.6.8 2.3 2.6 1-.7-1.1-1.3.4-1.4.7.8-2.1 2.7-1.1-.7 1.1-1.4zm-.6-1.3.4.5-.3-.7zm2.9.5.3-.5v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff700",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M47 16.3s.4-.4.7-.4m-.7.3 2.5-.4m-2.4.4 2.6-.2m-2.6.2H50m-3 0 2.8.1m-2.7 0 2.6.1m-2.7-.1s2.7.2 3 .5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff700",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M50 17.3s-.8-1-3-1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff700",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M47 16.3s1.5 0 2 .6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff700",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M47 16.2s1-.1 2 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m46.5 17.4 1.3.1c0 .2-1 .4-1 1s.7.6.8 1.3c0 .7-.6.8-.7 1-.2 0-.5 1-.4 1.6s.2 2.6.5 3c.2.2.5.7 1 .6.3-.2 0-.9 0-1l.2-.9-.2-.5s1.1.2 1 1.3c0 1-.4.7-.4.7s0 1.3-.2 1.4c-.6.4-1 0-1 0v.3l-.5-.3-.7-1.2-.2-2.4v-4.6c0-.3.5-1.4.5-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7000",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45 17s1-1 1.5-.8c.3 0 0 .2 0 .2s.5 0 .5.3h-.2l.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45 17s1-.2 1.5-.6m-.5.3h.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m48.7 27.5.8-.4c.1 0 .7.8-.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M48.5 22.3q.1.1-.1.8l-.5.5.1.5-.2.6.2 1m-.6-5q-.2 0-.7.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c75b00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M47.2 16.7s.1.5.7 0c-.4-.5-.7 0-.7 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M47.6 16.7h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.6 15.6s1 1.1 1.7 1.1c.2.3-.3.7-.4.8-.4-.1-.7 0-1.5-1zm1.4-2.7.7-.8a3 3 0 0 1 2-2.2c.2.7-.6 1.4-.6 1.4s2.4-.4 2.9-1c0 .3-.6 2-3.1 2 1 .9-.3 1.6-.9 1.4 1-.8-.2-1.3-1-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccd",
    stroke: "#ccc",
    strokeWidth: 0.1,
    d: "M44.9 12.3q.5-.4 1-.2h-.3l.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m44.7 12.1 1.4-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M43.8 17.5s1.4.4 1.5-1.5c-.3-.8-.7-2.6 0-3.1-.6-.4-1.2 0-1.2 0 0 .1-.6.8.1 2-1.6-.4-1 1.1-1 1.1.1-.2 1-.4 1.2.8 0 .3-.6.7-.6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M45.3 16s1.4-.7 1.4-2.5c-1.2 0-1.6 1.6-1.6 1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.1 16s-1 .8-1.6.5c-.4.3-1-.2-1-.2s.6 2.2 2.8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.5 16.5q.1-.8.7-.3c.4.1.8-1.5-.6-1.2.4-2-.7-2.8-.7-2.8s-.4 2.3-.3 2.7-.2-.8-1.7-1.2c0 1.8 1.6 2.6 1.6 2.6s.5.4 1 .2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M37.6 15s-.6.5-.5 1.3m-.5-1.4.2 1.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.5 16.4s.3-.5 1 .1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.7 13s-1 0-.4 1c-.5.2-1.4-.5-.8-1.3-2.1 0-3-1.1-3-2 .6.6 2.1.3 2.7.7-.7-.6-.5-1.5-.5-1.5s1.8.6 2.2 2.3c-.2.3-.2.9-.2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M35.2 11.4c.3.3 1.3.4 1.7.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cccccd",
    stroke: "#ccc",
    strokeWidth: 0.1,
    d: "M35.6 12.5s.8-.1 1 .1l-.8.1.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923f00",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.4 6.5s.4-.4.9 0c-.2.5-1 .3-1 .3v.5l.3.4s.7-.1.9.2h.5l.8-.2 1 .3c0 .2.2 1 .4 1 .1 0-.4.2-.5 0-.2-.2-.1.2-.1.2l.5.6s-.3.9 0 1.4q-.4.2-.3.3-.1.3-.3.3v-.4l-.3.2v-.3l.4-.9q-.1-.4-.5-.6c-.2 0-.4.7-.4.7v.6l-.2-.2-.2.4-.2.1V11c0-.1.5-.6.5-1v-.2l-.3-.4c0-.2-.4.2-.9 0l-.1 1v.8l-.2.3-.3.3v-.2l-.2.1v-.2l.3-1.2v-.9q-.2-.1-.4.5l-.1.6.1.6-.2.2-.5.3V11l.3-.6V9.3l-.4.1.2-.4c0-.2-.2.2-.5 0l.3-.5c0-.2-.1.1-.3 0l.2-.3h-.2l.1-.5-.1-.3L38 7v-.2s-.5.3-1-.3c.5-.4 1-.1 1-.1q-.1-.2.7-.4c.5 0 .6.4.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.5 12.9s1 0 1 .5q0 .7-.2.5l-.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fffeff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M41.5 12.7s1.3 0 1.3.6q-.3.6-.4.4h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40.8 12.6.7.1s.5 0 .5.5-.5.4-.5.4h-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39 12.9s-1 0-1 .5q.1.7.3.5l.8-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40 12.7s-1.3 0-1.2.6q.2.6.4.4h.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40.8 12.6-.8.1q-.2-.1-.4.5.2.5.4.4h.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e0043",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M42.8 18.9s.5-.8.8-.7c.2 0 0 .7 0 .7zM39 19c-.2-.2-.4-.9-.7-.7-.2 0 0 .7 0 .8z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M39.4 17.5s1 .6 1.4.6 1.5-.8 1.5-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e0043",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m39.5 15 .2-.3 1 .5 1-.5.3.2-1.2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    stroke: "#474747",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M38.7 14.9q.6.7.9 1.6v-1s.7.4.8.7c0 .3.3 0 .4 0l-2.4-1.6zm4 0s-.8 1-.7 2.3c-.2-.6 0-1.5 0-1.5h-.2s-.2.9-.5 1v-.1l-.3.3v1.2s0 .8.2.8l-.3.1v-2l.2-.2.3-.8-.3.1s0 .6-.2.6v.3l-.1-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m40.8 16.2.1 3.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M38.7 17.8q.2 0 .5.9c1.3-.1 1.7.3 1.7.3s1-.5 1.5-.4l.7-.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b4b6b9",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m38.2 14.5 2.6 1.7 2.3-1.6s.5-.3.5-.5q0-.2-.3 0l-2.5 1.7-2.5-1.7-.2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#474747",
    stroke: "#474747",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M42.8 14s-.6-.3-.6 0l.1.4v.3l-.1-.2-.5-.3q.1-.2-.1-.4-.3 0-.5.4l-.3.8v-1.3l2 .2h.1zm-2.3-.3-.9.2c-.1 0 .3.2.2.3q0 .3-.2.3l-.9-.5h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M40.8 13.5v1.6m-1.3-3.4-.7 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "m40.9 11.6.3.6.2.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m40.9 11.6.3.6.2.5m.7-1.1-.7 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M38.6 7h-.2l-.1-.2h.2V7m.3 0h.2l.1-.2H39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M47 27h-.3s-.8.1-.8 0l-.1.2h.1l.3.1v.1h1.3zm.4.4h-1l-.3.3h.2v.3h.1l1.7-.1q.6-.3.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m44 29.5 1.7-.1-.3-.3 5-.2-.3-.4-5.5.2.7.3h-1.5v.2h-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M46 19.4c-.2 0-.8-.2-1.5.3v1.6s1-.5 1.5-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m35.9 24.4-4.3 4.2m6.2-4.2L34.3 29m3.3-5.8L33 28.8m-.1 0 .4-.6m5.2-2.2-1.8 2.5m0 .3v1m2.7-3-2 2.5M39 29l.8-1.3m-.5-.2-1 1m.7-2-.6.8m-.2-2s-2 2.9-1.9 3.1M38 25l-1.7 2.2m0 .6-.4.4m-.3.6-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9396",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M35.7 17.8q-.2.1 0 .6l1 2s.5-.8.7-.8.1 1.8.1 1.8q-.1.2-.5.3c-.2 0 .5.7.5 1.3s-1 3.8-1.3 3.8.1-.6.1-.7c0-.2 0 0-.2-.3l.1-.6-.2-.3v-.3l-.1-.3V24c0-.2 0 .2-.3.2s-.4.5-.4.5-.4.6-.8.3c.3.5 0 .8 0 .8l-.2.4c-.2.2.2.9 0 1q.2.2 0 .3s-.7 0-.5.9q-3-1.2-2.8-3-.1-2 1.3-2.7c.2-1 .7-2 .7-2v-.8q0-.3.3-.5v-1l.1-.7c0-.2 0-1.2.2-1.3l.7-.3.7-.3.4.2s1 0 1 .4l-.2.5q.2.1-.4 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cecfcf",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m34.9 16.5-.2.2h-.2l.1-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.7 16.6h-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M36 17.2s.3 1 0 1.8m.2-2.2s.4.6.3 1.3m-.3-1.4s.4.3.4.5m-.3-.7.3.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M36.2 16.4s-1 1.5-.8 2.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M36.2 16.4s-1.1.7-1.4 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "m36.1 16.8-.5.3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M34.4 19.5s.7-2.7 1.8-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m36.7 20.4.7-.8c.2 0 .1 1.8.1 1.8l-.5.4.5 1v.4l-.2-.5c-.2-.3 0-.6-1-1.4-.2-.5.5.3.6.2s-.2-1.1-.2-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m35.6 16-.3.2-.3.2-.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34 17q-.2.2-.1.3l.4-.3s0 .6.1.5l.7-.4h.2s.4.4.7.2l-.3.5s-.3.4-.7.3l-.4-.3h-.4l-.2-.3q0 .1-.2 0s0-.5.3-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M36.3 16.4s-.7-.2-1 .1q-.3.6 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m36.4 16.3-.1.2q-.2 0-.2-.2l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m34.3 18.2.6.6c.4 0-.2.2-.5 0l-.2-.6zm2.5 2.6-1-1.2.4.2c.2.2 0-.4 0-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M34.2 27.5c.3-.1 1.7.8 2 1s1 0 1 0l-.5.3h.6s-1.8.5-3.6-.4c-.2-.8.4-1 .5-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m36.2 21.1-.3-.2-.5-.6-1.3-.6h-.5l-.1.2q-.2.3-.2.7l.7.8v.4l.5.5.2.2-.5.6-.4.3q-.1.4.5.6l1.4-.1v-.6l-.3-.2-.3.1H35s.3-.5.4-.4c0 0 .5 0 .6.3q0 .5.4.4t.7-.7a1 1 0 0 0-.4-1l-.4-.3v-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "m31.4 23.4 1-.2c.3 0 1.1.4 1.4.6.2.3.7.9 1 .8l.5-.1-.1.2h-.4q-.3 0-.7-.3c-.3-.2-1-1-1.8-1-.7.1-1 .8-1 .8v-.4l-.2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M34.6 24.1h.6l.5-.1v-.3l.3.3h-.2s-.6.5-.8.4q-.5 0-.5-.3Zm-1.3.7-.5.1-.2.1-.2-.1q0-.2.6-.2.4 0 .3.1Zm1.1.9s0-.5-.2-.6l-.5-.2.4.3.2.6-.4-.3h-.6c0 .2.4 0 .6.3l.2.6v-.2h.2v-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m34.2 27.1-.3-.5q0-.2-.3-.5H33c0 .2.5.3.5.4v.2h-.7c-.2 0-.4-.6-.3-.6h-.2v-.7L32 25s0-2.3 1.9-.4c-.8-1-1.1-.9-1.3-.9 0 0-.8 0-1 1s-.4.3-.4.3l.2.6q.2.2 0 .4s-.4-.8-.4-1.2q-.1.5.4 1.8a6 6 0 0 0 2.2 1.6q.9-1.3.7-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8a9396",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m33 27.2.4.2q.3.4.2.5 0-.3.2-.3l.2-.2s-.4-.5-.6-.5l-.5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8a9396",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "M33.8 28.1s1 .5 2.6.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeLinecap: "round",
    strokeWidth: 0.1,
    d: "m37 23.6-.6 2.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#2b2b2b",
    strokeWidth: 0.1,
    d: "M37 24.1q0 .2-.8 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m34.1 34.2.2-.2v.1l.2.2h.1V34l.2.1-.3.3-.3-.3m.4-.4.3-.3h.1v.1h-.1l-.1.1v.1h.1v-.1l.2.1H35v.1h.1v-.2l.1.1-.3.4V34zm.6-.6.2-.1h.2v.4l-.2.1H35v-.4m0 0v.3h.3v-.2zm.6-.5.3-.2h.2v.1H36l.1.3h.1l-.2.2-.1-.3-.1.1zm.4-.3.4-.2h.2v.1h-.3v.2-.1h.1l.1.1h-.1v.2h.1v-.3h.2v.2l-.4.3v-.1l-.1-.3zm.6-.3.3-.2h.1l.1.2v.1h.2l-.1.2-.3-.1h.1v.1l-.2.2v-.1zm.2 0h.1zm.3-.3.3-.1h.2q.2 0 0 .1v.1h.2v.2l-.3-.1v.1l-.1.2v-.1l-.1-.3zm.8-.3.3.3h.1l-.2.1v-.1H38v.1h.1l-.2.1zm.4-.2h.3l.1.2v-.3h.3v.4h.1l-.2.1v-.4.4h-.2l-.2-.3v.3h.1l-.1.1v-.4zm1-.2h.5v.1l-.1.1v.2h-.2v-.3zm.6-.1h.5v.3h.1v.1h-.1l-.2-.2v.2H40zm.2 0h.2zm.7-.1h.2l.1.2v.3h-.4l-.1-.3zm0 0v.4h.2V31zm.4 0h.4l.1.1v.1h-.2v.2h-.3zm.2 0v.2h.1zm.4 0h.4l.1.1v.1h-.2l.1.2h.1v.1h-.1l-.2-.2v.1zm.2 0v.2h.1zm.4 0h.3v.1l-.1.3v.1h-.2zm.6 0 .2.4v.1H43v-.2.1h-.2zm0 .4V31zm.4-.2h.2v.3l.2-.2h.2v.1l-.1.3v.1h-.2v-.1l.1-.4-.2.4v-.4l-.2.3h.1v.1h-.2v-.1zm1 .2.3.1.1.1v.2h-.3v.2h-.2v-.1l.2-.3zm.6.2.3.2v.2h-.1v.2h.1v.1h-.2v-.3H45v.2h-.2v-.2l.2-.2zm.8.4.2.2v.2l-.2.1h-.2l-.2-.1V32l.2-.1zm0 .1-.1.1v.2h.2V32m.4.1.3.2v.2-.1h-.1l-.2.2v.1H46v-.1h.1l.2-.3h-.2zm.5.4.3.2v.2-.2h-.2.1v.2h-.1v-.1h-.1v.1h.1q0 .1 0 0h.2v.1l-.2.1-.3-.2zm.5.7.2.1v.1l-.2.1h-.1v-.1l-.2-.1V33h.2q0-.1.1 0h.3v.3h-.1V33h-.3zm.6.1v.6h-.1l-.2-.1h.1v-.2h-.1v.1l-.2-.1h.1zm-.2.2v.1zm.5.2.3.2v.2h-.1V34l-.3.1v.1l-.2-.1h.1l.2-.3H48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M.7 0h26.6v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.8 0 14 7.5 24 0h3.3v2.6l-10 7.4 10 7.5V20H24l-10-7.5L4 20H.7v-2.5l10-7.4-10-7.4V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m18.3 11.7 9 6.6V20L16 11.7zm-7.6.8.2 1.5-8 6H.7zM27.3 0v.1L17 8V6l8.3-6zM.7 0l10 7.3H8L.7 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.7 0v20h6.7V0zM.7 6.7v6.6h26.6V6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M.7 8v4h26.6V8zM12 0v20h4V0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 43.7,
    x2: 43.8,
    y1: 12.5,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 43.1,
    x2: 43.1,
    y1: 19.6,
    y2: 20.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b50000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 47.8,
    x2: 49.6,
    y1: 20.3,
    y2: 20.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 43.4,
    x2: 44,
    y1: 12.1,
    y2: 12.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 52.6,
    x2: 52.3,
    y1: 29.2,
    y2: 27.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 48.3,
    x2: 47.5,
    y1: 21,
    y2: 19.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d5dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs);
export default __webpack_public_path__ + "static/media/gs.d18a8b037916eed39d797c6ea39765d7.svg";
export { ForwardRef as ReactComponent };